import type { ExtensionsCommandFactory } from '../ExtensionsModel';
import { getExtensionDetails } from './api/getExtensionDetailsApi';
import { getExtensionLogs } from './api/getExtensionLogsApi';

export const showExtensionDetailsDialog: ExtensionsCommandFactory<{
  extensionId: string;
  canSeeLogs: boolean;
}> = (cmdContext) => async (command) => {
  try {
    cmdContext.updateState((draft) => {
      draft.extensionsLoading = true;
    });

    const [selectedExtension, logsResponse] = await Promise.all([
      getExtensionDetails(cmdContext.api, command.extensionId),
      command.canSeeLogs
        ? getExtensionLogs(cmdContext.api, command.extensionId)
        : null,
    ]);

    cmdContext.updateState((draft) => {
      draft.readonlyExtensionDialogOpen = true;
      draft.extensionDetails = {
        extension: selectedExtension,
        logs: logsResponse?.logs ?? [],
        logsRefreshing: false,
        mode: 'readonly',
      };
    });
  } finally {
    cmdContext.updateState((draft) => {
      draft.extensionsLoading = false;
    });
  }
};
